import { formatMoney } from "@/components/restaurant/finance/constants";
import { getRestaurantCurrency } from "@/utils/currency";
import { billingMissing, capabilities, firmState, initials, ownLink, payingText } from "./firmsLogic";

const PAYING_LABEL_KEYS = { 1: "by_month", 2: "by_percent", 3: "by_meal", 4: "by_delivery" };
const STATE_TONES = { active: "ok", paused: "warn", inactive: "plain", deleted: "bad" };

/**
 * Tekstovi firmi za dostavu (stanje, plaćanje, ime). Lokalizovani, pa nisu u čistoj logici.
 * Dijelovi ekrana (koji injektuju reportShell) i sama ljuska dijele isti rječnik; grad se traži u ljusci.
 */
export default {
  computed: {
    userType() {
      const user = this.$store.state.user && this.$store.state.user.user;
      return user ? user.type : "";
    },
    restaurantId() {
      const restaurant = this.$store.state.restaurant;
      return restaurant && restaurant.id ? Number(restaurant.id) : 0;
    },
    restaurantCurrency() {
      return getRestaurantCurrency(this.$store.state.restaurant);
    },
  },
  methods: {
    firmName(firm) {
      return this.toLatin(firm.name);
    },
    firmInitials(firm) {
      return this.toLatin(initials(firm));
    },
    stateOf(firm) {
      return firmState(firm, this.restaurantId);
    },
    stateTone(firm) {
      return STATE_TONES[this.stateOf(firm)];
    },
    stateText(firm) {
      return this.$t(`delivery_firms.state.${this.stateOf(firm)}`);
    },
    linkOf(firm) {
      return ownLink(firm, this.restaurantId);
    },
    isBillingMissing(firm) {
      return billingMissing(firm, this.restaurantId);
    },
    can(firm) {
      return capabilities(firm, { userType: this.userType, restaurantId: this.restaurantId });
    },
    payTypeLabel(type) {
      return PAYING_LABEL_KEYS[type] ? this.$t(PAYING_LABEL_KEYS[type]) : "";
    },
    /** valuta firme, pa valuta restorana, pa KM */
    firmCurrency(firm) {
      return firm.currency || this.restaurantCurrency || "KM";
    },
    /** "2,00 KM" ili "15,00 %" ili "" kad naplata nije unesena */
    payAmountText(type, amount, currency = "KM") {
      return payingText(type, amount, { currency, number: (value) => formatMoney(value, "") });
    },
    cityLabel(firm) {
      const shell = this.reportShell || this;
      return this.toLatin(shell.cityName(firm.cityId));
    },
  },
};
